import { Injectable } from '@angular/core';
import { HttpOptionsModel } from '@myModels/Shared/http-options';
import { CustomHttpService } from '@myServices/custom-http.service';
import {catchError, map} from 'rxjs/operators';
@Injectable()
export class GamehistoryService {

  constructor(private customHttpService: CustomHttpService) { }

  getHistoryList(startDate, endDate) {
    const postData = {
        startDate: startDate,
        endDate: endDate
      };

    const httpOptions = new HttpOptionsModel('/game-history', postData, false, true);
    return this.customHttpService.post(httpOptions).pipe(
        catchError((error) => {
            if (error.error.messages) {
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map((res: any) => {
            return res;
        })
    );
  }

  getTransactionHistoryList(startDate, endDate) {
    const postData = {
      startDate: startDate,
      endDate: endDate
    };

    const httpOptions = new HttpOptionsModel('/profile/transactions', postData, false, true);
    return this.customHttpService.post(httpOptions).pipe(
        catchError((error) => {
            if (error.error.messages) {
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map((res: any) => {
            return res;
        })
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/gamehistory.service.ts